import { render, staticRenderFns } from "./update-grade.vue?vue&type=template&id=1ab17a0a&scoped=true&lang=pug"
import script from "./update-grade.vue?vue&type=script&lang=js"
export * from "./update-grade.vue?vue&type=script&lang=js"
import style0 from "./update-grade.vue?vue&type=style&index=0&id=1ab17a0a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ab17a0a",
  null
  
)

export default component.exports